module.exports = __webpack_public_path__ + "image/pro_icon6.png";